/* eslint-disable */
import React, {useState, useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import {Grid} from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import '../css/NewsletterPage.css';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Axios from 'axios';

/**
 * The component rendering articles on the newsletter page
 * @param {*} props post
 * @component ArticleBlock
 * @return {Component} ArticleBlock component
 */
function ArticleBlock(props) {
  const {post} = props;

  return (
    <Grid item xs={6} style={{marginTop: '20px'}}>
      <CardActionArea component="a" href={post.link}>
        <Card
          style={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            border: '1px solid silver',
          }}
        >
          <div className="archive-post">
            <div className="archive-post-image">
              <img src={post.image} title={post.imageText} />
            </div>
            <div className="archive-content">
              <p className="archive-category">{post.category}</p>
              <p style={{color: 'grey', fontSize: '19px'}}>{post.date}</p>
              <Typography
                component="h2"
                variant="h5"
                styles={{fontWeight: 'bold'}}
              >
                <div className="archive-post-title">{post.title}</div>
              </Typography>
            </div>
          </div>
        </Card>
      </CardActionArea>
    </Grid>
  );
}

ArticleBlock.propTypes = {
  post: PropTypes.object,
};

/**
 * This function renders the Newsletter page
 * @component NewsletterPage
 * @return {Component} NewsletterPage component
 */
export default function NewsroomPage() {
  const [articles, setArticles] = useState([]);
  const [initialArticles, setInitialArticles] = useState([]);
  const [sortedArticles, setSortedArticles] = useState({articles});
  const [refreshCount, setRefreshCount] = useState(0);
  const [initial, setInitial] = useState(true);

  useEffect(() => {
    if (initial) {
      Axios.get('https://ais-backend-server.herokuapp.com/api/articles').then(
        (res) => {
          let articles = res.data;
          articles = articles.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          });
          setArticles(articles);
          setInitialArticles(articles);
          setInitial(false);
          setRefreshCount(refreshCount + 1);
        }
      );
    }
  }, [refreshCount]);

  function sortByPriceNewest() {
    setRefreshCount(refreshCount + 1);
    articles.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    setSortedArticles({articles});
  }

  function sortByPriceOldest() {
    setRefreshCount(refreshCount + 1);
    articles.sort(function (a, b) {
      return new Date(a.date) - new Date(b.date);
    });
    setSortedArticles({articles});
  }

  function viewAll() {
    setSortedArticles({articles});
    setInitial(true);
    setRefreshCount(refreshCount + 1);
  }

  function viewArticles() {
    let list = [];
    let i;
    for (i = 0; i < initialArticles.length; i++) {
      if (initialArticles[i].category === 'ARTICLE')
        list.push(initialArticles[i]);
    }
    setArticles(list);
    setRefreshCount(refreshCount + 1);
  }

  function viewStatements() {
    let list = [];
    let i;
    for (i = 0; i < initialArticles.length; i++) {
      if (initialArticles[i].category === 'STATEMENT')
        list.push(initialArticles[i]);
    }
    setArticles(list);
    setRefreshCount(refreshCount + 1);
  }

  return (
    <Card className="archive-container">
      <div className="archive-left">
        <div className="archive-sort">
          <h3>Order</h3>
          <RadioGroup defaultValue="newest">
            <FormControlLabel
              value="newest"
              control={<Radio />}
              label="Newest"
              onChange={sortByPriceNewest}
            />
            <FormControlLabel
              value="oldest"
              control={<Radio />}
              label="Oldest"
              onChange={sortByPriceOldest}
            />
          </RadioGroup>
        </div>
        <div className="archive-sort">
          <h3>Type</h3>
          <RadioGroup defaultValue="all">
            <FormControlLabel
              value="all"
              control={<Radio />}
              label="View All"
              onChange={viewAll}
            />
            <FormControlLabel
              value="articles"
              control={<Radio />}
              label="Articles"
              onChange={viewArticles}
            />
            <FormControlLabel
              value="statements"
              control={<Radio />}
              label="Statements"
              onChange={viewStatements}
            />
          </RadioGroup>
        </div>
      </div>
      <div className="archive-right">
        <h1>Newsroom</h1>
        <p>{articles.filter((post) => post.active).length} Articles</p>
        <Grid container spacing={3}>
          {articles.map((post, index) =>
            post.active ? <ArticleBlock post={post} key={index} /> : <></>
          )}
        </Grid>
      </div>
    </Card>
  );
}
